// External libraries
import { useRecoilValue } from 'recoil';
import { IoIosSearch } from 'react-icons/io';

// CSS
import '../../styles/main.css'

// Components
import { Button, ButtonTheme, ButtonVariant, Body, BodyColor, BodyType, Heading, Search, TypographyColor, TypographyType, Switch, SpinnerLite } from '../../ui-elements';
import { checkboxState, shimmerLiteState, spinnerLiteState, spinnerState, stackRankState } from '../../states';
import { BreakDownTableComponent } from './index';

// Utilities
import * as Constants from '../../utils/constants/Constants'
import NoPoi from '../../pages/NoPoi';
import { useEffect } from 'react';
import { useCompareService } from '../../services';
import { StackRankDropdownDashboard } from './StackRankDropdownDashboard';
import { GeoType } from '../../constants';
import { TableSkeletonLoader } from '../home/TableSkeleton';

interface EhProps {
    breakDownTableData: any;
    tableRef: any;
    selectedBreakDownIndex: number;
    searchTerm: string;
    selectedBreakDown: string;
    handleBreakDownTypeChange: (item: string, index: number) => void;
    switchRef: any;
    toggleSwitch: (e: any) => void;
    searchRef: any;
    openSearch: boolean;
    handleInputChange: (value: string) => void;
    handleSearchClick: () => void;
    downloadCsvData: () => void;
    selectedDashboardStackRankKeys: any;
    setSelectedDashboardStackRankKeys: (selectedDashboardStackRankKeys: any) => void,
    setSelTableHeader: (selTableHeader: any) => void;
    selTableHeader: any
    stackrankRef: any
    isDropdownOpen: boolean
    setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
    selectedGeoType: string,
    setIsOpenDrawer: (value: boolean) => void,
    setIsrequestFromTable: (value: boolean) => void,
    setGeoName: (value: any) => void,
}


export const Eh = ({ breakDownTableData, tableRef, selectedBreakDownIndex, searchTerm, selectedBreakDown, handleBreakDownTypeChange, switchRef, toggleSwitch, searchRef, openSearch, handleInputChange, handleSearchClick, downloadCsvData, selectedDashboardStackRankKeys, setSelectedDashboardStackRankKeys, setSelTableHeader, selTableHeader, stackrankRef, isDropdownOpen, setIsDropdownOpen, selectedGeoType, setIsOpenDrawer, setIsrequestFromTable, setGeoName }: EhProps) => {
    const spinner = useRecoilValue(spinnerState);
    const spinnerLite = useRecoilValue(spinnerLiteState);
    const shimmerLite = useRecoilValue(shimmerLiteState);
    const isChecked = useRecoilValue(checkboxState);

    //stackrank
    const compareService = useCompareService();
    const stackRankOptions = useRecoilValue(stackRankState);


    // ===================== Fetch Stack Rank Options on Mount =====================
    useEffect(() => {

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleClickOutside = (event: MouseEvent) => {
        if (stackrankRef.current && stackrankRef.current.contains(event.target as Node)) {
            return; // ignore inside clicks
        }
        setIsDropdownOpen(false); // always close on outside click
    };

    const getLabelByKey = (key: string) => {
        for (const opt of stackRankOptions.State) {
            // match parent
            if (opt.key === key) return opt.label;

            // match children
            if (opt.children) {
                const child = opt.children.find((child: any) => child.key === key);
                if (child) return child.label;
            }
        }

        return key; // fallback
    };

    return (
        <div
            style={{ padding: '2.8125vh' }}
            className='w-100 d-flex flex-column justify-content-start align-items-start'
        >
            {shimmerLite.includes('breakDownTableData')
                ? <div className="w-100 d-flex flex-column justify-content-start align-items-start position-relative">
                    {/* Title */}
                    <div className='w-100 position-relative' style={{ height: '2.5vh', marginBottom: '1.5vh' }}>
                        <div className="shimmer position-absolute" style={{ width: '40%', borderRadius: '4px' }}></div>
                    </div>

                    {/* Subtitle */}
                    <div className='w-100 position-relative' style={{ height: '1.8vh', marginBottom: '2vh' }}>
                        <div className="shimmer position-absolute" style={{ width: '50%', borderRadius: '4px' }}></div>
                    </div>

                    {/* Breakdown Table Header Shimmer */}
                    <div className='w-100 position-relative' style={{ height: '3.774vh', marginBottom: '2vh' }}>
                        <div className="shimmer position-absolute" style={{ width: '60%', borderRadius: '4px' }}></div>
                    </div>

                    {/* Table Shimmer */}
                    <div className='w-100 position-relative' style={{ height: '56.45vh', marginBottom: '2vh' }}>
                        <TableSkeletonLoader rows={8} />
                    </div>
                </div>
                : <div className="w-100 d-flex flex-column justify-content-start align-items-start">
                    <div className='w-100 d-flex flex-row justify-content-between align-items-start'>
                        <Heading
                            title='Insights on EH'
                            type={TypographyType.h3}
                            colour={TypographyColor.primary}
                            classname='text-start text-truncate'
                        />
                        {/* {cifType === 'PoI' &&
                    <div ref={catCheckBoxRef} className="border rounded">
                        <POICategoryList page="Dashboard" isOpen={isListOpen} handleListOpen={() => setIsListOpen(!isListOpen)} />
                    </div>
                } */}
                    </div>
                    <Heading
                        title='Focus on the EH of underlying locations to shortlist your ideal micromarket.'
                        type={TypographyType.h6}
                        colour={TypographyColor.secondary}
                        classname='text-start text-truncate margin-bottom-2'
                    />
                    {breakDownTableData && breakDownTableData?.breakDownwiseData?.length > 0 &&
                        ((breakDownTableData.breakDownwiseData[0] && Object.keys(breakDownTableData.breakDownwiseData[0]).length > 0) ||
                            (breakDownTableData.breakDownwiseData[1] && Object.keys(breakDownTableData.breakDownwiseData[1]).length > 0)) &&
                        <div className='w-100'>
                            <div style={{ height: '3.774vh' }} className='margin-top-bottom-4 w-100 d-flex flex-row justify-content-between align-items-center'>
                                <div className='w-auto d-flex flex-row justify-content-start align-items-center'>
                                    {breakDownTableData.breakdownType &&
                                        Constants.breakdowntypeHeader[
                                            breakDownTableData.breakdownType as keyof typeof Constants.breakdowntypeHeader
                                        ]?.map((item, index) => (
                                            <div key={`parent-${index}`} className='height-4vh d-flex flex-column justify-content-between align-items-center'>
                                                <Heading
                                                    key={index}
                                                    title={item}
                                                    type={TypographyType.h5}
                                                    colour={selectedBreakDown === item ? TypographyColor.primary : TypographyColor.secondary}
                                                    classname={`text-center text-truncate margin-left-right-4`}
                                                    onClick={() => handleBreakDownTypeChange(item, index)}
                                                />
                                                <hr className={`m-0 w-100 ${selectedBreakDown === item && 'selected-cat'}`} />
                                            </div>
                                        ))
                                    }
                                </div>
                                <div className='height-3-774vh w-auto d-flex flex-row justify-content-start align-items-center gap-2'>
                                    <Switch
                                        ref={switchRef}
                                        isChecked={isChecked.MBP}
                                        toggleSwitch={toggleSwitch}
                                        name='MBP'
                                    />

                                    <Body
                                        type={BodyType.p3}
                                        color={BodyColor.secondary}
                                        classname=''
                                    >
                                        My Business Presence
                                    </Body>
                                    <div ref={searchRef} className='position-relative d-flex align-items-center'>
                                        {openSearch
                                            ? <Search
                                                handleInputChange={handleInputChange}
                                                searchTerm={searchTerm}
                                                hideSuggestionBox={true}
                                                placeholderValue='Search'
                                                classname='map-filters w-100 border height-3rem'
                                            />
                                            :
                                            <Button
                                                theme={ButtonTheme.secondary}
                                                variant={ButtonVariant.bordered}
                                                type='button'
                                                classname='dashboard-icon-wrapper'
                                            >
                                                <IoIosSearch className='fs-16 header-icon' onClick={() => handleSearchClick()} />
                                            </Button>
                                        }
                                    </div>
                                    {(breakDownTableData?.breakDownwiseData?.length > 0 && breakDownTableData.breakDownwiseData[selectedBreakDownIndex] && Object.keys(breakDownTableData.breakDownwiseData[selectedBreakDownIndex]).length > 0) &&
                                        <Button
                                            theme={ButtonTheme.secondary}
                                            variant={ButtonVariant.bordered}
                                            type='button'
                                            classname='dashboard-icon-wrapper d-flex justify-content-center align-items-center'
                                            onClick={() => downloadCsvData()}
                                        >
                                            <span className="material-symbols-outlined fs-18 header-icon"
                                            >
                                                download
                                            </span>
                                        </Button>
                                    }
                                </div>
                            </div>
                            <div className='w-100 d-flex pb-3 gap-1' style={{ height: '6.63vh' }}>
                                <div className="border rounded" ref={stackrankRef}>
                                    <StackRankDropdownDashboard
                                        isOpen={isDropdownOpen}
                                        handleListOpen={() => setIsDropdownOpen(prev => !prev)}
                                        stackRankOptions={stackRankOptions[selectedGeoType === "Pincode" ? "PinCode" : selectedGeoType] || []}
                                        selectedOptions={selectedDashboardStackRankKeys[selectedGeoType as GeoType] || []}
                                        selectedGeoType={selectedGeoType}
                                        setSelectedDashboardStackRankKeys={setSelectedDashboardStackRankKeys}
                                        selectedDashboardStackRankKeys={selectedDashboardStackRankKeys[selectedGeoType as GeoType] || []}
                                    />
                                </div>
                                {selectedDashboardStackRankKeys[selectedGeoType]
                                    ?.filter((item: any) => {
                                        // Hide CTV when geo type is subdistrict, pincode, or villages
                                        if ((selectedGeoType === "Subdistricts" || selectedGeoType === "Pincode" || selectedGeoType === "Villages") && item === "CTV") {
                                            return false;
                                        }
                                        return true;
                                    })
                                    ?.map((item: any, index: number) => (
                                        <div
                                            key={index}
                                            className='d-flex flex-row border rounded align-items-center ps-2'
                                            style={{ backgroundColor: '#F8F8F8' }}
                                        >
                                            <Heading
                                                title={getLabelByKey(item)}
                                                type={TypographyType.h5}
                                                colour={TypographyColor.primary}
                                                classname=''
                                            />
                                            <Button
                                                theme={ButtonTheme.secondary}
                                                variant={ButtonVariant.transparent}
                                                type="button"
                                                classname="close-button d-flex justify-content-center align-items-center p-1 h-auto m-0"
                                                onClick={() => {
                                                    const updated = selectedDashboardStackRankKeys[selectedGeoType as GeoType].filter(
                                                        (val: any) => val !== item
                                                    );
                                                    if (updated.length === 0) {
                                                        setSelectedDashboardStackRankKeys((prev: any) => {
                                                            const updatedObj = { ...prev, [selectedGeoType]: ['EH'] };
                                                            localStorage.setItem("selectedDashboardStackRankKeys", JSON.stringify(updatedObj)); // ✅ persist
                                                            return updatedObj; // ✅ update state
                                                        });
                                                    } else {
                                                        setSelectedDashboardStackRankKeys((prev: any) => ({ ...prev, [selectedGeoType]: updated })); // ✅ update state
                                                        localStorage.setItem("selectedDashboardStackRankKeys", JSON.stringify({ ...selectedDashboardStackRankKeys, [selectedGeoType]: updated })); // ✅ persist
                                                    }
                                                }}
                                            >
                                                <span className="material-symbols-outlined cursor-pointer color-black fs-20 p-0">
                                                    close
                                                </span>
                                            </Button>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }

                    {
                        breakDownTableData
                            && breakDownTableData.breakDownwiseData?.length > 0 && breakDownTableData.breakDownwiseData[selectedBreakDownIndex] && Object.keys(breakDownTableData.breakDownwiseData[selectedBreakDownIndex]).length === 0
                            ? <div className='w-100 height-73-45vh padding-top-5'><NoPoi /></div>
                            : ((breakDownTableData
                                && breakDownTableData.breakDownwiseData?.length > 0)
                                && (<div className='w-100' style={{ minHeight: 'fitContent', maxHeight: '56.45vh' }}>
                                    <BreakDownTableComponent
                                        ref={tableRef}
                                        tableContent={breakDownTableData.breakDownwiseData[selectedBreakDownIndex]}
                                        searchTerm={searchTerm}
                                        setSelTableHeader={setSelTableHeader}
                                        selTableHeader={selTableHeader}
                                        setIsOpenDrawer={setIsOpenDrawer}
                                        setIsrequestFromTable={setIsrequestFromTable}
                                        setGeoName={setGeoName}
                                        type={'breakdownTable'}
                                        retainValue={true}
                                    />
                                </div>)
                            )
                    }
                </div>
            }
        </div>
    );
};